import { WithId } from 'django-rest-react'
import { sentry_log } from './sentry'

export interface Displayable extends WithId {
  display: string
}



/**
 * Prende una ministringa che è l'id di un displayable
 * e restituisce il nome guardabile
 */
export function displayDisplayable(obj: string, family: Displayable[]): string {
  const match = family.find((item) => item.id === obj);
  if (match) {
    return match.display;
  } else {
    sentry_log(new Error(`Non matchato il seguente: ${obj}`));
    return "";
  }
}
